// @flow

import React from 'react';
import './ApartmentDeviationList.css';
import _ from 'lodash/fp';

const getDeviationName =
  _.getOr('', 'name');

export type Props = {
  list: any[],
  deviations: any[],
  onSelectItem: Function,
  onRemoveItem: Function,
};

const ApartmentDeviationList = ({list, deviations, onSelectItem, onRemoveItem}: Props) => (
  <div className="ApartmentDeviationList">
    <label>
      Avvikelser
    </label>
    <div className="deviation-list">
      {(!list || !list.length) &&
        <div className="empty-item">
          Inga avvikelser
        </div>
      }
      {!!(list && list.length) &&
        _.map(d => (
          <div
            key={d.id}
            className="row no-row-margins item">
            <button
              onClick={() => onSelectItem(d)}
              type="button"
              className="button column warning">
              {getDeviationName(_.find({id: d.id}, deviations) || {})}
            </button>
            <button
              onClick={() => onRemoveItem(d)}
              type="button"
              className="button column shrink">
              <i className="fa fa-trash"></i>
            </button>
            <button
              onClick={() => onSelectItem(d)}
              type="button"
              className="button column shrink">
              <i className="fa fa-pencil"></i>
            </button>
          </div>
        ), list)
      }
    </div>
  </div>
);

export default ApartmentDeviationList;



// WEBPACK FOOTER //
// ./src/components/ApartmentDeviationList/ApartmentDeviationList.js